import { useTranslation } from "react-i18next";
import Page from "app/shared/UI/Layout/Page";
import studyFilters from "app/components/study/StudyFilters";
import StudyListingPageContent from "app/components/study/StudyListingPageContent";

const StudyListingPage = (props) => {
  const { t } = useTranslation();

  return (
    <Page
      hasDrawer={true}
      drawerComponent={studyFilters}
      pageTitle={t("pageTitle.studyListing")}
      hasBackButton={false}
      contentComponent={StudyListingPageContent}
      {...props}
    />
  );
};

export default StudyListingPage;
